//icons
import {
	Instagram,
	Facebook,
	Github,
	Telegram,
	Youtube,
	Download,
} from '@styled-icons/bootstrap'
import { Vk } from '@styled-icons/entypo-social'
import { ShapeIntersect } from '@styled-icons/fluentui-system-regular'

//images
import avatar from '../../assets/images/ava.jpeg'

//libs
import { motion } from 'framer-motion'

const variants = {
	open: {
		translateX: '0%',
	},
	closed: {
		translateX: '-100%',
	},
	transition: {
		duration: 500,
	},
}

function InfoMenu(props) {
	return (
		<motion.aside
			variants={props.animate && variants}
			initial='closed'
			animate={props.isOpen ? 'open' : 'closed'}
			transition='transition'
			className={props.className}
		>
			<div className='overflow-y-scroll px-[40px] pb-[35px]'>
				<div className='mx-auto w-[150px] h-[150px] mt-[50px] relative'>
					<img
						src={avatar}
						alt='avatar'
						className='object-cover rounded-full w-[150px] h-[150px]'
					/>
					<span
						className={
							'absolute bottom-[14px] right-[14px] w-[16px] h-[16px] bg-[#7EB942] rounded-full'
						}
					/>
				</div>
				<p
					className={
						'text-center mt-[31px] text-black dark:text-white text-[18px] font-medium'
					}
				>
					Тимофей Ващенко
				</p>
				<p className='text-center mt-[15px] text-dark-100'>
					Full-stack разработчик
				</p>
				<div className='flex items-center justify-center gap-[10px] mt-[15px]'>
					<a
						href='https://t.me/TimPhp'
						className={
							'w-[30px] h-[30px] bg-yellow-100 rounded-full flex items-center justify-center'
						}
					>
						<Instagram
							className={
								'fill-black dark:fill-white w-[18px] h-[18px]'
							}
						/>
					</a>
					<a
						href='https://t.me/TimPhp'
						className={
							'w-[30px] h-[30px] bg-yellow-100 rounded-full flex items-center justify-center'
						}
					>
						<Facebook
							className={
								'fill-black dark:fill-white w-[18px] h-[18px]'
							}
						/>
					</a>
					<a
						href='https://t.me/TimPhp'
						className={
							'w-[30px] h-[30px] bg-yellow-100 rounded-full flex items-center justify-center'
						}
					>
						<Github
							className={
								'fill-black dark:fill-white w-[18px] h-[18px]'
							}
						/>
					</a>
					<a
						href='https://t.me/TimPhp'
						className={
							'w-[30px] h-[30px] bg-yellow-100 rounded-full flex items-center justify-center'
						}
					>
						<Telegram
							className={
								'fill-black dark:fill-white w-[18px] h-[18px]'
							}
						/>
					</a>
					<a
						href='https://t.me/TimPhp'
						className={
							'w-[30px] h-[30px] bg-yellow-100 rounded-full flex items-center justify-center'
						}
					>
						<Youtube
							className={
								'fill-black dark:fill-white w-[18px] h-[18px]'
							}
						/>
					</a>
					<a
						href='https://t.me/TimPhp'
						className={
							'w-[30px] h-[30px] bg-yellow-100 rounded-full flex items-center justify-center'
						}
					>
						<Vk
							className={
								'fill-black dark:fill-white w-[18px] h-[18px]'
							}
						/>
					</a>
				</div>
				<div className='w-full h-[1px] bg-gray-100 dark:bg-dark-200 my-[25px]' />
				<div className='flex flex-col gap-[10px]'>
					<div className='flex items-center justify-between'>
						<p
							className={
								'bg-yellow-100 px-[5px] text-black dark:text-white'
							}
						>
							Возраст:
						</p>
						<p className={'text-black dark:text-white'}>14</p>
					</div>
					<div className='flex items-center justify-between'>
						<p
							className={
								'bg-yellow-100 px-[5px] text-black dark:text-white'
							}
						>
							Фриланс:
						</p>
						<p className={'text-green-100'}>Не занят</p>
					</div>
					<div className='flex items-center justify-between'>
						<p
							className={
								'bg-yellow-100 px-[5px] text-black dark:text-white'
							}
						>
							Адрес:
						</p>
						<p className={'text-black dark:text-white'}>
							Кропоткин
						</p>
					</div>
				</div>
				<div className='w-full h-[1px] bg-gray-100 dark:bg-dark-200 my-[25px]' />
				<div className='flex flex-col'>
					<p
						className={
							'text-[18px] font-medium text-black dark:text-white'
						}
					>
						Языковые навыки
					</p>
					<div className='flex flex-col mt-[15px] gap-[10px]'>
						<div className='flex flex-col'>
							<div className='flex items-center justify-between'>
								<p className={'text-dark-100 dark:text-white'}>
									Русский:{' '}
								</p>
								<p className={'text-dark-100 dark:text-white'}>
									100%
								</p>
							</div>
							<div
								className={
									'w-full h-[6px] border border-yellow-100 rounded-full flex items-center p-[1px] mt-[6px]'
								}
							>
								<div
									className={
										'w-full h-full bg-yellow-100 rounded-full'
									}
								></div>
							</div>
						</div>
						<div className='flex flex-col'>
							<div className='flex items-center justify-between'>
								<p className={'text-dark-100 dark:text-white'}>
									Английский:{' '}
								</p>
								<p className={'text-dark-100 dark:text-white'}>
									75%
								</p>
							</div>
							<div
								className={
									'w-full h-[6px] border border-yellow-100 rounded-full flex items-center p-[1px] mt-[6px]'
								}
							>
								<div
									className={
										'w-3/4 h-full bg-yellow-100 rounded-full'
									}
								></div>
							</div>
						</div>
					</div>
				</div>
				<div className='w-full h-[1px] bg-gray-100 dark:bg-dark-200 my-[25px]' />
				<div className='flex flex-col'>
					<p
						className={
							'text-[18px] font-medium text-black dark:text-white'
						}
					>
						Скилы
					</p>
					<div className='flex flex-col mt-[15px] gap-[10px]'>
						<div className='flex flex-col'>
							<div className='flex items-center justify-between'>
								<p className={'text-dark-100 dark:text-white'}>
									HTML:{' '}
								</p>
								<p className={'text-dark-100 dark:text-white'}>
									95%
								</p>
							</div>
							<div
								className={
									'w-full h-[6px] border border-yellow-100 rounded-full flex items-center p-[1px] mt-[6px]'
								}
							>
								<div
									className={
										'w-[95%] h-full bg-yellow-100 rounded-full'
									}
								></div>
							</div>
						</div>
						<div className='flex flex-col'>
							<div className='flex items-center justify-between'>
								<p className={'text-dark-100 dark:text-white'}>
									CSS:{' '}
								</p>
								<p className={'text-dark-100 dark:text-white'}>
									90%
								</p>
							</div>
							<div
								className={
									'w-full h-[6px] border border-yellow-100 rounded-full flex items-center p-[1px] mt-[6px]'
								}
							>
								<div
									className={
										'w-[90%] h-full bg-yellow-100 rounded-full'
									}
								></div>
							</div>
						</div>
						<div className='flex flex-col'>
							<div className='flex items-center justify-between'>
								<p className={'text-dark-100 dark:text-white'}>
									JS:{' '}
								</p>
								<p className={'text-dark-100 dark:text-white'}>
									80%
								</p>
							</div>
							<div
								className={
									'w-full h-[6px] border border-yellow-100 rounded-full flex items-center p-[1px] mt-[6px]'
								}
							>
								<div
									className={
										'w-[80%] h-full bg-yellow-100 rounded-full'
									}
								></div>
							</div>
						</div>
						<div className='flex flex-col'>
							<div className='flex items-center justify-between'>
								<p className={'text-dark-100 dark:text-white'}>
									PHP:{' '}
								</p>
								<p className={'text-dark-100 dark:text-white'}>
									96%
								</p>
							</div>
							<div
								className={
									'w-full h-[6px] border border-yellow-100 rounded-full flex items-center p-[1px] mt-[6px]'
								}
							>
								<div
									className={
										'w-[96%] h-full bg-yellow-100 rounded-full'
									}
								></div>
							</div>
						</div>
						<div className='flex flex-col'>
							<div className='flex items-center justify-between'>
								<p className={'text-dark-100 dark:text-white'}>
									Wordpress:{' '}
								</p>
								<p className={'text-dark-100 dark:text-white'}>
									60%
								</p>
							</div>
							<div
								className={
									'w-full h-[6px] border border-yellow-100 rounded-full flex items-center p-[1px] mt-[6px]'
								}
							>
								<div
									className={
										'w-[60%] h-full bg-yellow-100 rounded-full'
									}
								></div>
							</div>
						</div>
						<div className='flex flex-col'>
							<div className='flex items-center justify-between'>
								<p className={'text-dark-100 dark:text-white'}>
									Laravel:{' '}
								</p>
								<p className={'text-dark-100 dark:text-white'}>
									97%
								</p>
							</div>
							<div
								className={
									'w-full h-[6px] border border-yellow-100 rounded-full flex items-center p-[1px] mt-[6px]'
								}
							>
								<div
									className={
										'w-[97%] h-full bg-yellow-100 rounded-full'
									}
								></div>
							</div>
						</div>
						<div className='flex flex-col'>
							<div className='flex items-center justify-between'>
								<p className={'text-dark-100 dark:text-white'}>
									ReactJs:{' '}
								</p>
								<p className={'text-dark-100 dark:text-white'}>
									84%
								</p>
							</div>
							<div
								className={
									'w-full h-[6px] border border-yellow-100 rounded-full flex items-center p-[1px] mt-[6px]'
								}
							>
								<div
									className={
										'w-[84%] h-full bg-yellow-100 rounded-full'
									}
								></div>
							</div>
						</div>
					</div>
				</div>
				<div className='w-full h-[1px] bg-gray-100 dark:bg-dark-200 my-[25px]' />
				<div className='flex flex-col'>
					<p
						className={
							'text-[18px] font-medium text-black dark:text-white'
						}
					>
						Доп. навыки
					</p>
					<div className='flex flex-col gap-[5px] mt-[15px]'>
						<div className={'flex items-center'}>
							<ShapeIntersect
								className={'w-[18px] h-[18px] fill-yellow-100'}
							/>
							<p
								className={
									'ml-[15px] text-[15px] text-dark-100 dark:text-white'
								}
							>
								Tailwind CSS, Bootstrap
							</p>
						</div>
						<div className={'flex items-center'}>
							<ShapeIntersect
								className={'w-[18px] h-[18px] fill-yellow-100'}
							/>
							<p
								className={
									'ml-[15px] text-[15px] text-dark-100 dark:text-white'
								}
							>
								VueJs, NuxtJs
							</p>
						</div>
						<div className={'flex items-center'}>
							<ShapeIntersect
								className={'w-[18px] h-[18px] fill-yellow-100'}
							/>
							<p
								className={
									'ml-[15px] text-[15px] text-dark-100 dark:text-white'
								}
							>
								Sass, Scss
							</p>
						</div>
						<div className={'flex items-center'}>
							<ShapeIntersect
								className={'w-[18px] h-[18px] fill-yellow-100'}
							/>
							<p
								className={
									'ml-[15px] text-[15px] text-dark-100 dark:text-white'
								}
							>
								Git, yarn
							</p>
						</div>
					</div>
				</div>
				<div className='w-full h-[1px] bg-gray-100 dark:bg-dark-200 my-[25px]' />
				<form action='#'>
					<button
						className={
							'bg-yellow-100 h-[40px] w-full text-black dark:text-white'
						}
					>
						Скачать резюме{' '}
						<Download
							className={
								'fill-black dark:fill-white w-[18px] h-[18px] ml-1'
							}
						/>
					</button>
				</form>
			</div>
		</motion.aside>
	)
}

export default InfoMenu
